import React, { useState, useEffect } from "react";
import axios from "axios";

// Load API URL from environment variables
const API_BASE_URL = process.env.REACT_APP_API_URL;

function EditablePrice({ initialPrice, symbol, onPriceUpdate }) {
  const [price, setPrice] = useState(initialPrice);
  const [editing, setEditing] = useState(false);
  const [message, setMessage] = useState("");
  const [csrfToken, setCsrfToken] = useState("");

  // Fetch CSRF token on mount
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}api/csrf/`, { withCredentials: true })
      .then((response) => {
        setCsrfToken(response.data.csrfToken);
      })
      .catch((error) => {
        console.error("CSRF token fetch error", error);
      });
  }, []);

  useEffect(() => {
    setPrice(initialPrice); // Ensure price is updated when initialPrice changes
  }, [initialPrice]);

  const handleEditClick = () => {
    setEditing(true);
  };

  const handleSaveClick = async () => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}api/oximo/${symbol}/?timestamp=${new Date().getTime()}`,
        { price: parseFloat(price) }, // Convert price to float
        {
          headers: {
            "X-CSRFToken": csrfToken, // Send CSRF Token
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      console.log("✅ API Response:", response.data);
      setMessage(response.data.message || "Price updated successfully");

      // ✅ Force state update to reflect new price
      setPrice(response.data.price || "No price");

      // ✅ Notify parent component to update displayed price
      if (onPriceUpdate) {
        onPriceUpdate(response.data.price);
      }

      setEditing(false);
    } catch (error) {
      console.error("❌ Error updating price:", error);
      setMessage("Error updating price");
    }
  };

  return (
    <div>
      {editing ? (
        <div>
          <input
            type="number"
            step="0.01"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
          <button onClick={handleSaveClick}>Save</button>
        </div>
      ) : (
        <div>
          <span>{price ? `₦${price}` : "No price"}</span>{" "}
          <button onClick={handleEditClick}>Edit</button>
        </div>
      )}
      {message && <p>{message}</p>}
    </div>
  );
}

export default EditablePrice;
